import OAuth2Callback from './OAuth2Callback';

export default OAuth2Callback;
